import Vue from 'vue'
import Vuex from 'vuex'
import instantQuote from './modules/instantQuote'


Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        instantQuote,
    }
})
